import "./style.css";
import Share from "../Share";

export default class ArticleShare {
  static selector = ".article__share";

  constructor(block) {
    this.block = block;

    const shares = [block];
    shares.map(el => new Share(el));
  }
}
